// Urls
export const GET_INVOICE_DATA_API = 'invoice/info';
export const UPDATE_INVOICE_DATA_API = 'invoice/info';

// Queries
export const INVOICE_QUERY_KEY = 'INVOICE_QUERY_KEY';
